import 'moment/locale/fr';
import moment from 'moment-timezone';
moment.locale('fr');
export function formatValue(value, valueType) {
    if (valueType === 'percentage') {
        return value % 1 === 0 ? `${parseInt(value)}%` : `${value.toFixed(2)}%`;
    } else {
        return value % 1 === 0 ? `${parseInt(value)}€` : `${value.toFixed(2)}€`;
    }
}

export function formatDate(value) {
    if (value) {
        return moment(value).tz('Europe/Paris').format('D MMMM YYYY à HH:mm');
    }
}
